"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useL10nDateTimeContext = exports.L10nDateTimeProvider = void 0;
var _format = _interopRequireDefault(require("date-fns/format"));
var _intlFormat = _interopRequireDefault(require("date-fns/intlFormat"));
var _formatRelative = _interopRequireDefault(require("date-fns/formatRelative"));
var _formatDistance = _interopRequireDefault(require("date-fns/formatDistance"));
var _formatDistanceToNow = _interopRequireDefault(require("date-fns/formatDistanceToNow"));
var _formatDistanceStrict = _interopRequireDefault(require("date-fns/formatDistanceStrict"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const L10nDateTimeContext = /*#__PURE__*/(0, _react.createContext)();
const L10nDateTimeProvider = _ref => {
  let {
    children,
    selected
  } = _ref;
  const [locale, setLocale] = (0, _react.useState)(selected);
  const value = (0, _react.useMemo)(() => ({
    locale,
    onChange: setLocale,
    hourCycle: new Intl.DateTimeFormat(locale.localeCode, {
      hour: 'numeric'
    }).resolvedOptions().hourCycle,
    get is24Hours() {
      return (
        // this is a false-positive, we are not accessing "this"
        // like a class component, it's just for the this returned object
        // in the useMemo callback return
        // eslint-disable-next-line react/no-this-in-sfc
        this.hourCycle === 'h23' || this.hourCycle === 'h24'
      );
    },
    DateTimeFormat: function () {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Intl.DateTimeFormat(locale.localeCode, options);
    },
    intlFormat: function (date) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, _intlFormat.default)(date, options, {
        locale: locale.localeCode
      });
    },
    format: function (date) {
      let formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'PP';
      return (0, _format.default)(date, formatStr, {
        locale
      });
    },
    formatRelative: (date, baseDate) => (0, _formatRelative.default)(date, baseDate, {
      locale
    }),
    formatDistance: (date, baseDate) => (0, _formatDistance.default)(date, baseDate, {
      locale
    }),
    formatDistanceToNow: date => (0, _formatDistanceToNow.default)(date, {
      locale
    }),
    formatDistanceStrict: (date, baseDate) => (0, _formatDistanceStrict.default)(date, baseDate, {
      locale
    })
  }), [locale]);
  (0, _react.useEffect)(() => {
    setLocale(selected);
  }, [selected]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(L10nDateTimeContext.Provider, {
    value: value,
    children: children
  });
};
exports.L10nDateTimeProvider = L10nDateTimeProvider;
const useL10nDateTimeContext = () => (0, _react.useContext)(L10nDateTimeContext);
exports.useL10nDateTimeContext = useL10nDateTimeContext;